<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">Q-Studio</div>
      </div>

      <img
        class="pwmat-introduce-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-title">
          <div class="pwmat-introduce-content-title-text">Q-Studio简介</div>
          <div class="pwamt-introduce-line"></div>
        </div>
        <div class="pwmat-introduce-content-info">
          <p class="pwmat-introduce-content-info-text">
            Q-Studio是一款原子尺度的材料建模应用，主要用于辅助用户进行第一性原理计算前的晶体结构准备工作，与云平台应用<a
              href="//www.pwmat.com/pwm-gui-introduce"
              >Q-Flow</a
            >配合，可以完成从材料建模到性质模拟的一整套流程。目前，Q-Studio
            V1.0版本已于2022年4月正式登陆<a
              href="https://mcloud.lonxun.com"
              >龙讯超算云平台</a
            >，已注册用户可以直接点击Q-Studio图标打开应用，开始材料建模工作。
          </p>
          <div class="mstation-introduce-content-img">
            <img
              class="mstation-introduce-content-img-png"
              src="../../assets/produce/QStudio/qstudio-function.png"
            />
          </div>
          <p class="pwmat-introduce-content-info-text">
            Q-Studio基于开源软件Jmol开发，在原有基础上完善了晶体结构的展示及建模功能。目前具有的主要功能有建立晶格、本地结构导入（支持pwmat、cif、vasp格式）、结构导出（支持pwmat、cif格式）、修改晶格常数、建立超胞、添加删除原子、修改元素、移动原子、对称性限制下的拖拽原子、建立超胞、测量距离/角度/二面角。
          </p>
          <p class="pwmat-introduce-content-info-text">
            使用Q-Studio建模时，可以直接选中部分原子并建立群组，方便在后续建模操作中重新选中群组内原子，如小分子、团簇等。
          </p>
          <p class="pwmat-introduce-content-info-text">
            Q-Studio作为前处理应用，可以直接选中原子进行固定或设置初始磁矩，从而生成在后续第一性原理计算中可读的pwmat格式结构文件。
          </p>
          <p class="pwmat-introduce-content-info-text">
            Q-Studio功能目前正处在快速迭代期，构造表面结构、建立真空层、建立吸附体系、数据库结构导入、绘制分子等新功能将在近期上线。
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/1访问qs20220419_155517.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">
            通过龙讯超算云平台访问Q-Studio
          </p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/2建立晶格20220420_100652.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">建立晶格</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/3修改晶格20220420_101120.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">修改晶格</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/4添加原子20220420_100800.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">添加原子</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/5建立超胞20220420_100840.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">建立超胞</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/6移动原子20220420_100913.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">移动原子</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/7修改元素20220420_101003.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">修改元素</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/8固定原子20220420_101156.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">固定原子</p>
        </div>
        <div class="mstation-introduce-content-img">
          <img
            class="mstation-introduce-content-img-png"
            src="../../assets/produce/QStudio/9建组20220420_101035.gif"
          />
          <p class="pwmat-introduce-content-info-img-text">建立群组</p>
        </div>
        <div class="pwmat-introduce-content-title" style="padding-top: 20px">
          <div class="pwmat-introduce-content-title-text">相关下载</div>
          <div class="pwamt-introduce-line"></div>
        </div>

        <div class="pwmat-introduce-content-info">
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toMSTATIONDownload"
          >
            PWmat下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toModuleDownload"
          >
            Module下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toManual"
          >
            手册下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            @click="toPotentialDownload"
          >
            赝势下载
          </p>
          <p
            class="pwmat-introduce-content-info-text"
            style="display: inline-block; margin-right: 30px; cursor: pointer"
            onclick="location.href='http://mcloud-doc.lonxun.com'"
          >
            Mcloud手册
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PWMAT_RESOURCE } from "./../../helpers/consts";
export default {
  name: "companyIntroduce",
  data() {
    return {
      PWMAT_RESOURCE,
    };
  },
  methods: {
    toMSTATIONDownload() {
      this.$router.push({ name: "MSTATIONDownload" });
    },
    toPotentialDownload() {
      this.$router.push({ name: "PotentialDownload" });
    },
    toModuleDownload() {
      this.$router.push({ name: "ModuleDownload" });
    },
    toManual() {
      window.open(this.PWMAT_RESOURCE + "Manual.pdf");
    },
    toProchureBook() {
      window.open(this.PWMAT_RESOURCE + "prochure.pdf");
    },
  },
};
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-title {
  padding-top: 50px;
}
.pwmat-introduce-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.pwmat-introduce-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.pwmat-introduce-content-info-img-text {
  font-size: 18px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 6px;
}
.pwamt-introduce-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.mstation-introduce-content-img {
  text-align: center;
}
.mstation-introduce-content-img-png {
  margin-top: 20px;
  width: 100%;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
